import React, { useEffect, useState }  from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {
  Modal,
  Result,
} from "antd";


const ModalAddTeamAuto = ({
  isModalAddTeamAuto,
  setModalAddTeamAuto,
  currentTeam,
  lsTeam,
  onAddTeamAutoAttend
}) => {
  const [nameTeam, setNameTeam] = useState([]);

  useEffect(() => {
    if (currentTeam.length === 0) {
      setNameTeam([]);
      return;
    }
    setNameTeam(lsTeam.filter(f=>currentTeam[0] == f.idTeam)[0].team)
  }, []);

  return (
    <>
      <Modal
        title=""
        open={isModalAddTeamAuto}
        onCancel={()=>setModalAddTeamAuto(false)}
        footer={false}
        width={450}
        className={"site-drawer-render-in-current-wrapper"}
        bodyStyle={{ padding: "0px 12px 12px 12px" }}
        maskClosable={false} // Tắt click ra ngoài để đóng
      >
        <Result
          title={`Xác nhận cài tự động chấm công ca sáng thứ 7 cho team ${nameTeam}`}
          extra={
            <Button type="primary" key="console" onClick={()=>onAddTeamAutoAttend(currentTeam)}>
              Cài chấm công
            </Button>
          }
        />
      </Modal>
    </>
  );
};

export default ModalAddTeamAuto;
